import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../../../app.config';
import {
    catchErrorLogRet,
    mapList,
    mapUpdate,
} from '../../../common/rest.operators';

import { Category } from './category.model';
import { Item } from './item.model';

@Injectable()
export class ApiService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    listCategories(userId: number): Observable<Category[]> {
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.NOTIFICATION}/event-centre/${userId}/categories`,
            )
            .pipe(mapList(), catchErrorLogRet(null));
    }

    updateItem(item: Item): Observable<string> {
        return this._http
            .patch(
                `${this._appConfig.API_ENDPOINTS.NOTIFICATION}/event-centre/${item.targetUserId}/items/${item.eventCentreItemId}`,
                item,
            )
            .pipe(mapUpdate(), catchErrorLogRet(null));
    }

    listItems(
        userId: number,
        startDate: Date,
        endDate: Date,
    ): Observable<Item[]> {
        const params = new HttpParams()
            .set('userId', String(userId))
            .set('startDate', startDate.toJSON())
            .set('endDate', endDate.toJSON());
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.NOTIFICATION}/event-centre/${userId}/items`,
                {
                    params,
                },
            )
            .pipe(mapList(), catchErrorLogRet(null));
    }
}
